import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit'
import { initialUserState } from 'store/user/initial.ts'
import { getUserLogins, getUsers } from 'store/user/thunks'

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {},
  extraReducers: (builder) => {
    // SPECIFIC THUNK REDUCERS
    builder.addCase(getUserLogins.fulfilled, (state, { payload }) => {
      state.logins = payload.logins
    })

    builder.addCase(getUsers.fulfilled, (state, { payload }) => {
      state.users = payload.users
    })

    // IS PENDING MATCHER
    builder.addMatcher(isPending(getUserLogins, getUsers), (state) => {
      state.loading = true
      state.error = false
    })

    // IS FULFILLED
    builder.addMatcher(isFulfilled(getUserLogins, getUsers), (state) => {
      state.loading = false
      state.error = false
    })

    // IS REJECTED
    builder.addMatcher(isRejected(getUserLogins, getUsers), (state) => {
      state.loading = false
      state.error = true
    })
  }
})

export default userSlice.reducer
